import { api } from ".";

export function login(data){
    return api.post('/login', data)
}